import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface DialogData {
  isSOC: boolean,
  isSupport: boolean,
  nspObj: ""
  NSPemail: "", 
  NSPphone: "", 
  NSPsoc: "",  
  nspTitle: "",
  nspTitleContacts: "",
  nspDescription: "",
  nspEmailTranslation: "",
  nspSOCTranslation: "",
  nspSOCLinkTranslation: "",
  nspPhoneTranslation: "",
  openTicket: "",
  openContacts: ""
}

@Component({ standalone: false,
  selector: 'vfa-cp-help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.scss'],
})
export class HelpDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private router: Router, private dialog: MatDialog){}
  public contactUs: boolean = false;

  ngOnInit() {
    this.contactUs = this.data.isSupport? false : true;
  }

  navigateBySupportNew() {
    this.router.navigateByUrl("dashboard/support/case/new");
    this.dialog.closeAll();
  }
}

